import { render } from "./CourseRevitationSubpage.vue?vue&type=template&id=69743e12&scoped=true"
import script from "./CourseRevitationSubpage.vue?vue&type=script&lang=js"
export * from "./CourseRevitationSubpage.vue?vue&type=script&lang=js"

import "./CourseRevitationSubpage.vue?vue&type=style&index=0&id=69743e12&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69743e12"]])

export default __exports__